/*
创建者 李伟(2018.9.08)
直营精品
*/
<template>
  <div class="boutique">
    <div class="boutique-top" :style="{background:`url(${topImgBg}) top center`}">
      <div class="wrapper">
        <ul class="superGoods-list">
          <li v-for="item in superGoods">
            <router-link :to="item.to" target="_blank">
              <img :src="item.atturl" :title="item.aname" width="323" height="209"/>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="wrapper">
      <!--<div class="b-title"><img :src="btitle01"/></div>
      <div class="clearfix">
        <div class="famous-goods-advert">
          <ul>
            <li v-for="item in famousGoodsAdvert">
              <router-link :to="item.to" target="_blank">
                <img :src="item.atturl"  width="190" height="305"/>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="famous-goods-list">
          <ul>
            <li v-for="item in famousGoods">
              <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                <img :src="item.url" :title="item.name" width="190" height="190"/>
              </router-link>
              <div class="goods-name">
                <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                  {{item.name}}
                </router-link>
              </div>
              <div class="goods-price">活动价:<em class="sale-price">¥{{item.price}}</em></div>
              <div class="add-cart">
                <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank"><i class="icon-cart m-r5" :style="{background:`url(${iconCart})`}"></i><span>立即购买</span></router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>-->
      <div class="b-title"><img :src="btitle02"/></div>
      <div class="clearfix">
        <ul class="goods-list">
          <li v-for="item in goodGoods">
            <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
              <img :src="item.url" :title="item.name" width="190" height="190"/>
            </router-link>
            <div class="goods-name">
              <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                {{item.name}}
              </router-link>
            </div>
            <div class="goods-price">活动价:<em class="sale-price">¥{{item.price}}</em></div>
            <div class="add-cart">
              <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank"><i class="icon-cart m-r5"
                                                                                                  :style="{background:`url(${iconCart})`}"></i><span>立即购买</span>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import topImgBg from '../../assets/images/boutique-top.jpg';
  import btitle01 from '../../assets/images/btitle01.jpg';
  import btitle02 from '../../assets/images/btitle02.jpg';
  import iconCart from '../../assets/images/icon-cart.png';
  import {getZgNiceGoods} from 'api/home';
  import {parseAdvList} from 'utils/tool';

  export default {
    data() {
      return {
        topImgBg,
        btitle01,
        btitle02,
        iconCart,
        superGoods: [],
        goodGoods: [],
        famousGoodsAdvert: {},
        famousGoods: {}
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getZgNiceGoodsData();
      })
    },
    methods: {
      getZgNiceGoodsData() {
        getZgNiceGoods().then(json => {
          if (json.resCode == '1') {
            this.superGoods = parseAdvList(json.data.superGoods.advList);
            this.goodGoods = json.data.goodGoods.goodsList;
            this.famousGoodsAdvert = parseAdvList(json.data.famousGoods.advInfo.advList);
            this.famousGoods = json.data.famousGoods.goodsList;
          } else {
            this.$Message.info(json.resDesc);
          }
        });
      }
    }
  }
</script>
<style lang="less">
  @import "../../assets/css/boutique.less";
</style>



// WEBPACK FOOTER //
// index.vue?179f48a0